var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavoriteOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon300_20_favorite_on"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_198_655",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_198_655)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "favorite"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 13.1513L7.39745 12.6064C6.30344 11.6261 5.40066 10.7895 4.68912 10.0968C3.97758 9.40405 3.41883 8.79337 3.01285 8.26474C2.60686 7.7361 2.32545 7.25683 2.16862 6.82692C2.01177 6.39701 1.93335 5.96026 1.93335 5.51667C1.93335 4.62608 2.24126 3.87288 2.85707 3.25707C3.47288 2.64126 4.22608 2.33335 5.11667 2.33335C5.66539 2.33335 6.19317 2.46391 6.7 2.72504C7.20683 2.98615 7.64017 3.35986 8 3.84618C8.35983 3.35986 8.79317 2.98615 9.3 2.72504C9.80683 2.46391 10.3346 2.33335 10.8833 2.33335C11.7739 2.33335 12.5271 2.64126 13.1429 3.25707C13.7587 3.87288 14.0667 4.62608 14.0667 5.51667C14.0667 5.96026 13.991 6.39145 13.8397 6.81025C13.6884 7.22905 13.4098 7.69999 13.0038 8.22307C12.5978 8.74615 12.0374 9.35961 11.3224 10.0635C10.6075 10.7673 9.68973 11.6261 8.56922 12.6397L8 13.1513ZM8 11.9833C9.03333 11.0568 9.88333 10.2675 10.55 9.61539C11.2167 8.96325 11.7472 8.39552 12.1417 7.91219C12.5361 7.42885 12.8111 6.99936 12.9667 6.62372C13.1222 6.24807 13.2 5.87906 13.2 5.51667C13.2 4.86111 12.9778 4.31111 12.5333 3.86667C12.0889 3.42222 11.5389 3.2 10.8833 3.2C10.4902 3.2 10.1231 3.2827 9.78205 3.44809C9.44103 3.61346 9.10128 3.87906 8.76282 4.24488L8.17948 4.92822H7.82052L7.23718 4.24488C6.89445 3.8748 6.54808 3.60812 6.19808 3.44487C5.84808 3.28162 5.48761 3.2 5.11667 3.2C4.46539 3.2 3.91646 3.42222 3.46987 3.86667C3.02329 4.31111 2.8 4.86111 2.8 5.51667C2.8 5.87906 2.87222 6.23974 3.01667 6.59872C3.16111 6.9577 3.425 7.37607 3.80833 7.85385C4.19167 8.33163 4.71944 8.8983 5.39167 9.55385C6.06389 10.2094 6.93333 11.0192 8 11.9833Z",
    fill: "#8C4FF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 11.9833C9.03333 11.0568 9.88333 10.2675 10.55 9.61539C11.2167 8.96325 11.7472 8.39552 12.1417 7.91219C12.5361 7.42885 12.8111 6.99936 12.9667 6.62372C13.1222 6.24807 13.2 5.87906 13.2 5.51667C13.2 4.86111 12.9778 4.31111 12.5333 3.86667C12.0889 3.42222 11.5389 3.2 10.8833 3.2C10.4902 3.2 10.1231 3.2827 9.78205 3.44809C9.44103 3.61346 9.10128 3.87906 8.76282 4.24488L8.17948 4.92822H7.82052L7.23718 4.24488C6.89445 3.8748 6.54808 3.60812 6.19808 3.44487C5.84808 3.28162 5.48761 3.2 5.11667 3.2C4.46539 3.2 3.91646 3.42222 3.46987 3.86667C3.02329 4.31111 2.8 4.86111 2.8 5.51667C2.8 5.87906 2.87222 6.23974 3.01667 6.59872C3.16111 6.9577 3.425 7.37607 3.80833 7.85385C4.19167 8.33163 4.71944 8.8983 5.39167 9.55385C6.06389 10.2094 6.93333 11.0192 8 11.9833Z",
    fill: "#8C4FF2"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteOn);
export default __webpack_public_path__ + "static/media/favorite_on.ee8b9051510479187e0afdad7eb605e8.svg";
export { ForwardRef as ReactComponent };